import axios from "axios";

export const state = {
    reportpaymentsbyoptions: [],
};

export const getters = {
    reportpaymentsbyoptions: state => state.reportpaymentsbyoptions,
};

export const mutations = {
    setReportPaymentsbyOptions(reportpaymentsbyoptions, newValue) { state.reportpaymentsbyoptions = newValue},
};

export const actions = {
    fetchReportPaymentsbyOptions({ commit }) {
        axios.get('/reportpaymentsbyoptions').then(res => {
            commit('setReportPaymentsbyOptions', res.data.payments)
        })
    },
    filterReportPaymentsbyOptions({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportpaymentsbyoptions";
        axios.post(url, formData).then((response) => {
            commit('setReportPaymentsbyOptions', response.data.payments)
        })
    },
};
